import { ChangeDetectionStrategy, Component, Inject, InjectionToken } from '@angular/core';

export type TooltipImage = string;
export const TOOLTIP_DATA = new InjectionToken<TooltipImage>('Image to display in tooltip');

@Component({
    selector: 'se-image-tooltip-container',
    templateUrl: './se-image-tooltip.component.html',
    styleUrls: ['./se-image-tooltip.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SeImageTooltipComponent {
    constructor(@Inject(TOOLTIP_DATA) public tooltipImage: TooltipImage) {}
}
